import { combineReducers } from 'redux';
import auth from "./auth";
import management from "./management";


const portalApp = combineReducers({
    auth, management,
})

export default portalApp;



// WEBPACK FOOTER //
// ./src/reducers/index.js